import { Box } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CursorType } from '../../configs/constant';
import ReportsTable from './ReportsTable';
import Pagination from '../../common/pagination/Pagination';
import { useAuth } from '../../hooks/useAuth';
import { useGetNotificationsReportQuery } from '../../services/report.service';
import {
  selectReportState,
  setReports,
  setLimit,
  setLoading,
  setError,
  setCursor, 
} from '../../state/modules/report/reportReducer';

const ReportsScreen = () => {
  const dispatch = useDispatch();
  const { auth: { currentUser } } = useAuth();

  const { reports, filters, limit, total, cursor, loading } = useSelector(selectReportState);
  const [paginate, setPaginate] = useState<CursorType>({});

  useEffect(() => {
    setPaginate({});
    dispatch(setCursor({ after: null, before: null })); 
  }, [filters]);

  const queryParams: any = {
    device_type: filters.deviceType !== 'all' ? filters.deviceType : undefined,
    // type: filters.diaryType !== 'all' ? filters.diaryType : undefined,
    from: filters.from ? Number(filters.from) : undefined,
    to: filters.to ? Number(filters.to) : undefined,
    receiver_id: filters.supervisor !== 'all' ? filters.supervisor : undefined,
    province: filters.province && filters.province !== 'all' ? filters.province : undefined,

    limit,
    ...(paginate.after ? { after: paginate.after } : {}),
    ...(paginate.before ? { before: paginate.before } : {}),
  };
  if (filters.diaryType === 'disconnected') {
    queryParams.status = 'disconnected';
  } else if (filters.diaryType !== 'all') {
    queryParams.type = filters.diaryType;
  }
  const { data, isLoading, isError } = useGetNotificationsReportQuery(queryParams);

  useEffect(() => {
    dispatch(setLoading(isLoading));

    if (isError) {
      dispatch(setError('Lỗi khi tải dữ liệu báo cáo'));
      return;
    }

    if (data && currentUser) {
      const safeData = Array.isArray(data.data) ? data.data : [];

      const combinedReports = safeData.map((item: any) => {
        let status = '';
        const messageLower = item.message?.toLowerCase() || '';
        if (item.type === 'alert') {
          status = 'Phát tín hiệu';
        } else if (item.type === 'warning') {
          if (messageLower.includes('mất kết nối')) status = 'Mất kết nối';
          else if (messageLower.includes('bật nguồn')) status = 'Bật nguồn';
          else if (messageLower.includes('tắt nguồn')) status = 'Tắt nguồn';
          else if (messageLower.includes('pin thấp')) status = 'Pin yếu';
          else status = 'Chưa xác định';
        }

        const typeDisplay = item.type === 'alert' ? 'Cảnh báo' :
          item.type === 'warning' ? 'Lưu ý' : item.type;

        return {
          id: item.id,
          timestamp: item.timestamp,
          type: typeDisplay,
          title: item.title,
          message: item.message,
          location_id: item.location_id,
          gateway_serial: item.gateway_serial,
          gateway_type_id: item.gateway_type_id,
          status,
          province: item.province,
        };
      });

      dispatch(setReports({
        reports: combinedReports,
        cursor: data.cusor || { after: null, before: null },
        total: data.total,
      }));
    }
  }, [data, isLoading, isError, currentUser, dispatch]);

  const handleSetLimit = (newLimit: number) => {
    dispatch(setLimit({ limit: newLimit }));
  };

  return (
    <Box mt={2} ml={2} mr={'12px'}>
      <ReportsTable reports={reports} loading={loading} />
      <Pagination
        paginate={cursor}
        total={total}
        setPaginate={setPaginate}
        limit={limit}
        setLimit={handleSetLimit}
      />
    </Box>
  );
};

export default ReportsScreen;